export const linkWithUTM = (
  link: string,
  source: string,
  medium: string,
  campaign: string,
): string => {
  if (link === "#") return "#"

  const url = new URL(link)
  const params = new URLSearchParams(url.search)

  params.set("utm_source", source)
  params.set("utm_medium", medium)
  params.set("utm_campaign", campaign)

  url.search = params.toString()
  return url.toString()
}
